package com.arena_web.ui.components.navigation

import androidx.compose.runtime.Composable
import com.arena_web.ui.components.icons.Icon
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText

enum class SidebarTab(val label: String, val icon: String, val route: String) {
    Arena("Arena", AppIcons.ProPlayLogo, "/arena"),
    Events("Feed", AppIcons.Globe, "/feed"),
    People("People", AppIcons.Radio, "/people"),
    Chat("Chat", AppIcons.Chat, "/chat"),
    Profile("Profile", AppIcons.Profile, "/profile")
}

@Composable
fun SidebarNav(
    activeTab: SidebarTab? = null,
    onTabSelected: (SidebarTab) -> Unit = {}
) {
    val sportColors = LocalSportColors.current
    val t = LocalAppStrings.current
    fun tabLabel(tab: SidebarTab): String = when (tab) {
        SidebarTab.Arena -> t.navArena
        SidebarTab.Events -> t.navFeed
        SidebarTab.People -> t.navPeople
        SidebarTab.Chat -> t.navChat
        SidebarTab.Profile -> t.navProfile
    }

    Row(
        Modifier.styleModifier { property("gap", s(4)) },
        verticalAlignment = Alignment.CenterVertically
    ) {
        SidebarTab.entries.forEach { tab ->
            if (tab == activeTab) {
                NavAnchor(tab.route, onNavigate = { onTabSelected(tab) }) {
                Row(
                    Modifier
                        .sHeight(48)
                        .sBorderRadius(28)
                        .backgroundColor(sportColors.primary)
                        .sPadding(8, 18)
                        .overflow(Overflow.Hidden)
                        .styleModifier {
                            property("box-shadow", "0px 4px 4px 0px rgba(0, 0, 0, 0.25)")
                            property("cursor", "pointer")
                            property("gap", s(8))
                        },
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        src = tab.icon,
                        modifier = Modifier.styleModifier {
                            property("filter", sportColors.iconFilterOnPrimary)
                        }
                    )
                    SpanText(
                        tabLabel(tab),
                        modifier = Modifier
                            .bodyLMedium()
                            .color(sportColors.onPrimary)
                    )
                }
                }
            } else {
                NavAnchor(tab.route, onNavigate = { onTabSelected(tab) }) {
                Box(
                    Modifier
                        .sSize(48)
                        .sBorderRadius(100)
                        .overflow(Overflow.Hidden)
                        .styleModifier {
                            property("border", "0.3px solid transparent")
                            property("background",
                                "${AppGradients.InteractiveSecondary} padding-box, " +
                                "linear-gradient(0deg, #02040B, #02040B) padding-box, " +
                                "${AppGradients.ButtonBorderGradientPrimary} border-box")
                            property("cursor", "pointer")
                        },
                    contentAlignment = Alignment.Center
                ) {
                    // Inactive tabs render in the muted nav-blue (#B4CCF6).
                    // IconDefaultFilter starts with brightness(0), so it also
                    // normalizes the saturated #0061FF Pro Play ring and the
                    // stray white sub-path in the radio icon to the same tone.
                    Icon(
                        src = tab.icon,
                        modifier = Modifier.styleModifier {
                            property("filter", AppColors.IconDefaultFilter)
                        },
                    )
                }
                }
            }
        }
    }
}
